import { Record } from 'immutable';

export default class CustomerAttestResourceRecord extends Record({
  id: undefined,
  approved: undefined,
  comment: undefined,
  resource: undefined,
}) {
}
